import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { ItemWithData, LoadFileComponent } from 'components';
import { activeStorageModel } from 'models';
import { withLocalization } from 'utils/enhancers';

function MultilanguageLoadFileComponent({ fieldName, value, handleChange, title, handleServerError, ...props }) {
  const [isUploading, setIsUploading] = useState(false);

  const handleSetFile = file => {
    if (!file) {
      handleChange({ signedId: null, fileName: null, remove: true });
    } else {
      setIsUploading(true);
      activeStorageModel.createUpload(file).create((error, blob) => {
        setIsUploading(false);
        if (error) {
          handleServerError(error);
        } else {
          handleChange({
            signedId: blob.signed_id,
            fileName: blob.filename,
            remove: false,
          });
        }
      });
    }
  };

  return (
    <ItemWithData title={title} key={fieldName}>
      <LoadFileComponent
        file={value.fileName}
        loadFile={handleSetFile}
        isLoading={isUploading}
        handleServerError={handleServerError}
        {...props}
      />
    </ItemWithData>
  );
}

MultilanguageLoadFileComponent.propTypes = {
  title: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.shape({ fileName: PropTypes.string }), PropTypes.string]).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleServerError: PropTypes.func.isRequired,
};

export const MultilanguageLoadFile = withLocalization(MultilanguageLoadFileComponent);
